// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, ButtonBase } from '@mui/material';

// project imports
import Logo from 'ui-component/Logo';
import MobileSection from './MobileSection';
import ProfileSection from './ProfileSection';
import TaskPinSection from './TaskPinSection';
import { useDispatch, useSelector } from 'store';
import { openDrawer } from 'store/slices/menu';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
    const theme = useTheme();

    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);

    return (
        <>
            {/* logo — click it to collapse/expand the sidebar menu */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <ButtonBase
                    disableRipple
                    aria-label="Toggle menu"
                    onClick={() => dispatch(openDrawer(!drawerOpen))}
                    sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}
                >
                    <Logo />
                </ButtonBase>
            </Box>

            {/* header search */}
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            <TaskPinSection />
            <ProfileSection />

            {/* mobile header */}
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                <MobileSection />
            </Box>
        </>
    );
};

export default Header;
